import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import toast, { Toaster } from "react-hot-toast";
import "./ContactModal.css";

const ContactModal = ({ isOpen, onClose }) => {
  const form = useRef();
  const [isSending, setIsSending] = useState(false);

  if (!isOpen) return null;

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);

    emailjs
      .sendForm(
        "service_tkzjy9o",
        "template_h86aiun",
        form.current,
        "6QHz_nz4KTqJ2RlG0"
      )
      .then(
        () => {
          // keepign theme lieek NavBar - nice clean sleek ----
          setIsSending(false);
          form.current.reset();
          toast.success("Message sent! I’ll get back to you soon ✨", {
            duration: 4000,
            position: "bottom-right",
            style: {
              // same clear/glass theme -----
              backdropFilter: "blur(12px)",
              background: "rgba(25, 25, 25, 0.45)",
              color: "#fff",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              boxShadow: "0 4px 25px rgba(0, 0, 0, 0.4)",
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "0.95rem",
            },
            iconTheme: {
              primary: "#4c8bf5",
              secondary: "#1a1a1a",
            },
          });
          setTimeout(onClose, 2000);
        },
        (error) => {
          setIsSending(false);
          toast.error("Something went wrong — try again soon ⚠️", {
            duration: 4000,
            position: "bottom-right",
            style: {
              backdropFilter: "blur(12px)",
              background: "rgba(30, 0, 0, 0.5)",
              color: "#fff",
              border: "1px solid rgba(255, 100, 100, 0.2)",
              boxShadow: "0 4px 25px rgba(0, 0, 0, 0.4)",
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "0.95rem",
            },
            iconTheme: {
              primary: "#ff5c5c",
              secondary: "#1a1a1a",
            },
          });
          console.error(error.text);
        }
      );
  };

  return (
    <>
      {/* <div className="modal-overlay" onClick={onClose}> */}
      <div className="modal-overlay">
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <h2>Contact Me</h2>
          <p>
            Thanks for reaching out! You can email me directly at{" "}
            <a href="mailto:savannah@svx.studio">savannah@svx.studio</a>, or
            send a quick message below.
          </p>

          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <label>Name</label>
            <input
              type="text"
              name="user_name"
              placeholder="Your name"
              required
            />

            <label>Email</label>
            <input
              type="email"
              name="user_email"
              placeholder="Your email"
              required
            />

            <label>Message</label>
            <textarea
              name="message"
              placeholder="Write your message here..."
              required
            />

            <button type="submit" disabled={isSending}>
              {isSending ? <span className="spinner"></span> : "Send Message"}
            </button>
          </form>

          <button className="close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>

      {/* Toast notifications */}
      <Toaster />
    </>
  );
};

export default ContactModal;
